import React from "react";
import InvestmentPlans from "./InvestmentPlans";

function ChoosePlan() {

  return (
    <>
      <InvestmentPlans />
    </>
  );
}

export default ChoosePlan;
